import * as React from 'react'
import { IOperatorProduct, IDriverSearchObject } from '../../types'
import FloatingForm from '../ui/form/FloatingForm'

export interface IProvidersProductsProps {
  operator: IDriverSearchObject
}

const DriverViewProvidersProducts = (props: IProvidersProductsProps) => {
  const { operator } = props
  if (!operator) {
    return null
  }

  return (
    <FloatingForm fullHeight={true}>
      <>
        <div className='form-modal-section full-section'>
          <div className='font-grey2 bold h5'>Driver Products</div>
          <div className='flex flex-wrap pt1 mt1 border-top'>
            {operator.products.map((product: IOperatorProduct) => (
              <span className='product-item' key={product.id}>
                {product.name}
              </span>
            ))}
          </div>
        </div>
      </>
    </FloatingForm>
  )
}

export default DriverViewProvidersProducts



// WEBPACK FOOTER //
// ./src/components/drivers/DriverViewProvidersProducts.tsx